import { render } from "./index.vue?vue&type=template&id=3d5066a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./alarm-table-global.scss?vue&type=style&index=0&lang=scss"
import "./alarm-table.scss?vue&type=style&index=1&id=3d5066a2&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5066a2"]])

export default __exports__